import PropTypes from "prop-types";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TableTitle = _ref => {
  let {
    id = "",
    className = "",
    secondary = "",
    onSecondaryTitleClick = null,
    style = {},
    secondaryStyle = {},
    children = null
  } = _ref;
  const newChildren = filterChildren(children);
  return /*#__PURE__*/_jsx("caption", {
    id: id,
    className: `bg-white text-brand-blue border-b border-b-light-border-blue rounded-t p-4 text-left text-xl relative ${className}`,
    style: style,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row xs:flex-col justify-between gap-2",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "text-base leading-6 truncate app-components-table-title__primary-title",
        children: newChildren
      }), secondary && /*#__PURE__*/_jsx("span", {
        className: "text-sm leading-5 whitespace-nowrap app-components-table-title__secondary",
        children: onSecondaryTitleClick ? /*#__PURE__*/_jsx("a", {
          className: "cursor-pointer",
          onClick: onSecondaryTitleClick,
          style: secondaryStyle,
          role: "link",
          tabIndex: 0,
          children: secondary
        }) : /*#__PURE__*/_jsx("span", {
          style: secondaryStyle,
          children: secondary
        })
      })]
    })
  });
};
TableTitle.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Secondary text or node */
  secondary: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** On Secondary text click function if clickable */
  onSecondaryTitleClick: PropTypes.func,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** Override the inline-styles of the secondary title element || Not Recommended */
  secondaryStyle: PropTypes.object,
  /** children props for content inside */
  children: PropTypes.node
};
export default TableTitle;
//# sourceMappingURL=TableTitle.js.map